import { useEffect, useState } from 'react';
import { getPageImages } from '../services/imageService';

export function useManagedImages({ pageKey, defaultImages }) {
  const [images, setImages] = useState(defaultImages || {});

  useEffect(() => {
    let active = true;

    async function loadImages() {
      try {
        const override = await getPageImages(pageKey);
        if (!active) {
          return;
        }
        setImages({ ...(defaultImages || {}), ...(override || {}) });
      } catch {
        if (active) {
          setImages(defaultImages || {});
        }
      }
    }

    loadImages();
    const intervalId = window.setInterval(loadImages, 10000);
    window.addEventListener('focus', loadImages);
    document.addEventListener('visibilitychange', loadImages);

    return () => {
      active = false;
      window.clearInterval(intervalId);
      window.removeEventListener('focus', loadImages);
      document.removeEventListener('visibilitychange', loadImages);
    };
  }, [defaultImages, pageKey]);

  return images;
}
